import { render, staticRenderFns } from "./CampaignSortOrder.vue?vue&type=template&id=343a9939&scoped=true&lang=pug"
import script from "./CampaignSortOrder.vue?vue&type=script&lang=js"
export * from "./CampaignSortOrder.vue?vue&type=script&lang=js"
import style0 from "./CampaignSortOrder.vue?vue&type=style&index=0&id=343a9939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343a9939",
  null
  
)

export default component.exports